/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Lustrace_History_EmptyInputs */

const cs_lustrace_history_empty = /** @type {(inputs: Lustrace_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím žádné uložené kontroly.`)
};

const en_lustrace_history_empty = /** @type {(inputs: Lustrace_History_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No saved checks yet.`)
};

/**
* | output |
* | --- |
* | "No saved checks yet." |
*
* @param {Lustrace_History_EmptyInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const lustrace_history_empty = /** @type {((inputs?: Lustrace_History_EmptyInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Lustrace_History_EmptyInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_lustrace_history_empty(inputs)
	return cs_lustrace_history_empty(inputs)
});